import React,{useState,useEffect,useRef} from 'react'
import SubHeader from '../../layout/components/SubHeader'
import PatientList from './PatientList'
import MessageBody from './MessageBody'
import Searchbar from './subparts/Searchbar'
import ContactList from './subparts/ContactList'
import ConversationList from './subparts/ConversationList'
import Loading from '../../common/Loading'
import { toast } from 'react-toastify';
import smsgatewayService from '../../../services/smsgateway.service';
import { useEyeconxStore } from '../../../store/eyeconxStore'
function Messages() {
      const [searchTerm, setSearchTerm] = useState('');
      const [searchCriteria, setSearchCriteria] = useState('firstName');
      const [users,setUsers] = useState([])
      const [loading,setLoading] = useState(false)
      const [nextPage,setNextPage] = useState(0)
      const [isLastPage,setIsLastPage] = useState(false)
      const [selectedUser, setSelectedUser] = useState(null);
      const [chat, setChat] = useState({});
      const [loadConversation,setLoadConversation] = useState(false)
      const [conversationDetails,setConversationDetails] = useState([])
      const [conversationDetailsLoading,setConversationDetailsLoading] = useState(false)
      const isMounted = useRef(false); // ref to track if the component is mounted
      const clinicId = useEyeconxStore(state => state.user.clinicId)
      const clinicInfo = useEyeconxStore(state => state.clinicInfo)

    useEffect(() => {
       // console.log("Function called ")
       
        if (!isMounted.current) {
          isMounted.current = true;
          getUserList();
        }
      }, []);


    const handleRefresh = ()=>{
        setSelectedUser(null)
        setConversationDetails(null)
        setUsers([])
        getUserList(0,30,"")
    }
    /* other functions */
    const getUserList = (pageNo=0,pageSize=30,searchString="")=>{
        console.log("Get User List")
        console.log("PageNo:"+pageNo+" PageSize: "+pageSize+" search String "+searchString)
        setLoading(true)
        smsgatewayService.getInbox(clinicId,searchCriteria,searchString,pageNo,pageSize)
        .then(res=>{
          console.log(res.data)
          //setUsers(res.data)
          setUsers((prevUser) => [...prevUser, ...res.data.content])
          setNextPage(res.data.pageable.pageNumber+1)
          setIsLastPage(res.data.last)
          setLoading(false)
        })
        .catch(err=>{
          toast.error("Error getting Users");
        })
    }

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };
    /* Seach Functions */
    const handleSearchChange = (strSearch) => {
        setUsers([])
        getUserList(0,30,strSearch)
    }
    const handleSearchCriteriaChange = (e) => {
        setSearchCriteria(e.target.value);
    }
    const handleReset = () => {
        setSearchCriteria("firstName")
        setSearchTerm("")
        setUsers([])
        getUserList(0, 30, "")
    }
  
  /* Contact List Functions */
  const handleUserSelect = (user) => {
    handleConversation(user)
    setSelectedUser(user);
  }
  const handleLoadMore = () => {
    console.log("Load More")
  }
 /* Conversation List Functions */
 const handleConversation = (user,pageNo=0,pageSize=30)=>{
     setLoadConversation(true)
     smsgatewayService.getConversation(clinicId,user,pageNo,pageSize)
     .then(res=>{
       console.log(res.data)
       console.log("Sms Chat Data")
       setChat(res.data)
       setLoadConversation(false)
     })
     .catch(err=>{
       toast.error("Error getting Conversation");
       setLoadConversation(false)
     })
  }
const handleSendMessage = (message,isConfirmationRequired=false) => {
    if (message.trim() === '' || !selectedUser) return;
       //add this message to chat.content array
   
       const sendNewMessage = {
         "clinicId": clinicId,
         "business": clinicInfo.sms,
         "customer": chat[0].customer,
         "message": message,
         "isConfirmationRequired": isConfirmationRequired
       }
   
       smsgatewayService.sendMessage(clinicId,sendNewMessage)
       .then(res=>{
         console.log(res.data)
         toast.success("Message Sent")
         const newMessage =  {
           "business": clinicInfo.sms,
           "customer": selectedUser,
           "message": res.data.message,
           "customerFirstName": chat[0].customerFirstName,
           "customerLastName": chat[0].customerLastName,
           "customerDob": chat[0].customerDob,
           "messageType": "OUTGOING",
           "status": "ACCEPTED",
           "modifiedDate": getTodayDate(),
           "modifiedTime": getCurrentTime()
       }
         
         //add to top of chat
          
         setChat(prevChat => [...prevChat,newMessage])
       })
       .catch(err=>{
         toast.error("Error sending Message");
       })
      
  }
  const getConversationDetails = (conversationId) => {
    setConversationDetailsLoading(true)
      smsgatewayService.getConversationDetails(clinicId,selectedUser)
      .then(res=>{
          setConversationDetails(res.data)
         // console.log("Conversation Details : ") 
         // console.log(res.data)
          setConversationDetailsLoading(false)
      })
      .catch(err=>{
          toast.error("Error getting Conversation Details");
          setConversationDetailsLoading(false)
      })
  }

  return (
    <>
        <SubHeader title="Messages" description={"Communicate with Patient using Messages"} />
         <div className='container'>
             <div className="row" style={{height:"80vh"}}>
                <div className="col-md-4">
                    <div className="d-grid">
                        <button className='btn btn-light-success rounded btn-sm mb-3' onClick={handleRefresh}> <i className="bi bi-arrow-repeat fs-4"></i> Refresh Messages</button>
                     </div>
                        <Searchbar
                              handleSearchChange ={handleSearchChange}
                              searchCriteria = {searchCriteria}
                              handleSearchCriteriaChange = {handleSearchCriteriaChange}
                              searchTerm = {searchTerm} 
                              handleReset = {handleReset}
                        />
                         {loading && loading?<Loading/>:
                            <ContactList 
                                users={users} 
                                handleUserSelect = {handleUserSelect} 
                                selectedUser= {selectedUser} 
                                handleLoadMore={handleLoadMore} 
                                lastPage={isLastPage} />
                        }
                       
                </div>
                <div className="col-md-8">
                {selectedUser ? (
                        <>
                        {
                            loadConversation && loadConversation ?
                                <Loading/>:<>
                                {chat && <ConversationList 
                                            smsData={chat} 
                                            handleSendMessage={handleSendMessage} 
                                            getConversationDetails={getConversationDetails} 
                                            conversationDetails={conversationDetails} 
                                            conversationDetailsLoading = {conversationDetailsLoading}/>}
                                            </>}
                        
                        
                        </>
                    ) : (
                        <div className="d-flex justify-content-center align-items-center flex-grow-1" >
                        <h4>Please select a user to view conversation</h4>
                        </div>
                    )}
                </div>
             </div>
         </div>
    </>
  )
}

export default Messages